import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetExportExcelRecentEventListFileQueryVariables = Types.Exact<{
  input: Types.GetExportExcelRecentEventListFileInput;
}>;

export type GetExportExcelRecentEventListFileQuery = {
  __typename?: 'Query';
  getExportExcelRecentEventListFile: {
    __typename?: 'GetExportExcelRecentEventListFileResponse';
    fileUrl?: string | null;
    message: string;
    status: string;
    success: boolean;
    fileName?: string | null;
  };
};

export const GetExportExcelRecentEventListFileDocument = gql`
  query GetExportExcelRecentEventListFile(
    $input: GetExportExcelRecentEventListFileInput!
  ) {
    getExportExcelRecentEventListFile(input: $input) {
      fileUrl
      message
      status
      success
      fileName
    }
  }
`;
export function useGetExportExcelRecentEventListFileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetExportExcelRecentEventListFileQuery,
    GetExportExcelRecentEventListFileQueryVariables
  > &
    (
      | {
          variables: GetExportExcelRecentEventListFileQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetExportExcelRecentEventListFileQuery,
    GetExportExcelRecentEventListFileQueryVariables
  >(GetExportExcelRecentEventListFileDocument, options);
}
export function useGetExportExcelRecentEventListFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetExportExcelRecentEventListFileQuery,
    GetExportExcelRecentEventListFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetExportExcelRecentEventListFileQuery,
    GetExportExcelRecentEventListFileQueryVariables
  >(GetExportExcelRecentEventListFileDocument, options);
}
export function useGetExportExcelRecentEventListFileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetExportExcelRecentEventListFileQuery,
        GetExportExcelRecentEventListFileQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetExportExcelRecentEventListFileQuery,
    GetExportExcelRecentEventListFileQueryVariables
  >(GetExportExcelRecentEventListFileDocument, options);
}
export type GetExportExcelRecentEventListFileQueryHookResult = ReturnType<
  typeof useGetExportExcelRecentEventListFileQuery
>;
export type GetExportExcelRecentEventListFileLazyQueryHookResult = ReturnType<
  typeof useGetExportExcelRecentEventListFileLazyQuery
>;
export type GetExportExcelRecentEventListFileSuspenseQueryHookResult =
  ReturnType<typeof useGetExportExcelRecentEventListFileSuspenseQuery>;
export type GetExportExcelRecentEventListFileQueryResult = Apollo.QueryResult<
  GetExportExcelRecentEventListFileQuery,
  GetExportExcelRecentEventListFileQueryVariables
>;
export function refetchGetExportExcelRecentEventListFileQuery(
  variables: GetExportExcelRecentEventListFileQueryVariables,
) {
  return {
    query: GetExportExcelRecentEventListFileDocument,
    variables: variables,
  };
}
